<template>
  <div id="blogpost" class="container-fluid px-0 blogpost">
    <script v-html="jsonld" type="application/ld+json" />
    <div class="container">
      <div class="row">
        <div class="col px-0">
          <router-view />
        </div>
      </div>
      <div class="row py-3">
        <div class="col px-0 text-left mx-blog">
          <router-link to="/blog"
            ><b-img
              class="icon-md mr-2 cursor-pointer"
              alt="arrow-left"
              :src="require('@/assets/icons/arrow-left.svg')"
            >
            </b-img
            >Voir plus d'articles</router-link
          >
        </div>
      </div>
      <div class="row py-3">
        <div class="col px-0 text-left mx-blog">
          <div class="d-flex align-items-center">
            <b-img
              class="icon-md mr-2 cursor-pointer"
              alt="teddi"
              :src="require('@/assets/logo/bear-face.png')"
            >
            </b-img>
            <strong>Teddi</strong>, Expert immobilier
          </div>
        </div>
      </div>
      <div class="row m-1 justify-content-center text-center py-5">
        <div class="col mx-auto bg-blue text-white text-left border-radius box-shadow">
          <div class="row py-5 justify-content-center align-items-center">
            <div class="col-md-2 d-flex justify-content-center">
              <div>
                <IconStars class="fill-white icon-md" />
              </div>
            </div>
            <div class="col-md-6 d-flex justify-content-center text-center text-md-left my-3">
              <div>
                <h3 class="text-bold mx-0 p-3 p-md-0">
                  Profitez de nos nouveaux services en suivant les étapes de votre parcours
                  immobilier
                </h3>
              </div>
            </div>
            <div class="col-md-2 d-flex justify-content-center">
              <div class="d-flex align-items-center">
                <b-link
                  :to="{ name: 'timeline-buy' }"
                  @click.native="$scrollToTop"
                  class="btn bg-white text-blue text-bold text-uppercase px-4 py-3 my-3 mr-3"
                  >Achat</b-link
                >
                <b-link
                  :to="{ name: 'timeline-rent' }"
                  @click.native="$scrollToTop"
                  class="btn bg-white text-blue text-bold text-uppercase px-4 py-3 my-3"
                  >Location</b-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/bottom/Footer.vue";
import IconStars from "@/components/icons/IconStars.vue";

export default {
  components: {
    Footer,
    IconStars,
  },
  metaInfo() {
    return {
      title: this.$router.currentRoute.meta.title,
      titleTemplate: "%s ← Teddi",
      meta: [
        { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        {
          name: "description",
          content: this.$router.currentRoute.meta.description,
        },
        {
          property: "og:title",
          content: this.$router.currentRoute.meta.title,
        },
        { property: "og:site_name", content: "Teddi" },
        { property: "og:type", content: "website" },
        {
          property: "og:url",
          content: window.location.href,
        },
        {
          property: "og:image",
          content: this.$router.currentRoute.meta.img,
        },
        {
          property: "og:description",
          content: this.$router.currentRoute.meta.description,
        },
      ],
      link: [{ rel: "canonical", href: window.location.href }],
    };
  },

  computed: {
    jsonld() {
      return {
        "@context": "http://schema.org",
        "@graph": [
          {
            "@type": "Article",
            url: window.location.href,
            headline: this.$router.currentRoute.meta.title,
            genre: "immobilier",
            datePublished: this.$router.currentRoute.meta.date,
            image: {
              "@type": "ImageObject",
              url: this.$router.currentRoute.meta.img,
            },
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": window.location.href,
            },
            publisher: {
              "@type": "Organization",
              "@id": "https://www.teddi.co",
              name: "Teddi",
              logo: {
                "@type": "ImageObject",
                url: "https://www.teddi.co/assets/socials/fb-profile.png",
                width: 1000,
                height: 1000,
              },
            },
            author: {
              "@type": "Person",
              name: "Teddi",
              jobTitle: "Real estate search engineer",
              image: "https://www.teddi.co/assets/socials/fb-profile.png",
            },
          },
          {
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                item: {
                  "@type": "WebPage",
                  "@id": "https://www.teddi.co/blog/",
                  name: "Recevez les annonces immobilières en premier - Blog",
                },
              },
              {
                "@type": "ListItem",
                position: 2,
                item: {
                  "@type": "WebPage",
                  "@id": "https://www.teddi.co/blog/" + this.$router.currentRoute.name,
                  name: this.$router.currentRoute.meta.title,
                  image: this.$router.currentRoute.meta.img,
                },
              },
            ],
          },
        ],
      };
    },
  },
  mounted() {
    let img = document.querySelector("p > img");
    let paragraphs = document.querySelectorAll("p");
    paragraphs.forEach(paragraph => {
      if (paragraph.contains(img)) {
        paragraph.classList.add("text-center");
      }
    });
  },
};
</script>

<style lang="scss">
#blogpost {
  .row-card {
    svg {
      align-self: start;
      margin-right: 1rem;
      width: 4rem;
      path {
        fill: white !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~bootstrap/scss/mixins";
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
::v-deep {
  h1 {
    background: $primary;
    padding: 3rem;
    color: white;
    border-radius: $radius;
    margin: 1.2rem;
    @include media-breakpoint-up(md) {
      margin: unset;
    }
  }
  section {
    li {
      list-style: disc;
      text-align: left;
      margin-left: 1.2rem;
      margin-right: 1.2rem;
      @include media-breakpoint-up(md) {
        margin-left: 12rem;
        margin-right: 12rem;
      }
    }
  }

  p,
  h2,
  h3,
  .mx-blog {
    text-align: left;
    margin-left: 1.2rem;
    margin-right: 1.2rem;
    @include media-breakpoint-up(md) {
      margin-left: 12rem;
      margin-right: 12rem;
    }
  }
  p {
    font-size: 1.1rem;
    img {
      width: 300px;
      max-width: 100%;
      padding: 2rem;
    }
  }
  h2 {
    font-size: 2.3rem;
  }
  h2,
  h3 {
    font-weight: bold;
  }
}
</style>
